var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from "react";
import Tabs from "./Tabs";
import { DrawerContext } from "../model/model";
import store from "../../reduxStore/store";
import { SalesRepDataActionType } from "../../reduxStore/actions/actionTypes";
import { useDispatch } from "react-redux";
import { EDIT_ORDER_FLAG, REDIRECT_TAB_FLAG } from "../Constant";
import { SALES_ORDER_DETAILS_MAIN_TAB_INDEX } from "../model/STOrderDetailsModel";
import { refreshStReportsThirtyDayCacheInBackground } from "../../reduxStore/actions/salesRepDataAction";
export function NavigationBL(props) {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var dispatch = useDispatch();
    var _j = useState(0), componentIndex = _j[0], SetComponentIndex = _j[1];
    var reduxActiveTabObj = (_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.activeTab) !== null && _b !== void 0 ? _b : {};
    var reduxEditOrderDataObj = (_d = (_c = store.getState().salesRepData) === null || _c === void 0 ? void 0 : _c.editDraftOrder) !== null && _d !== void 0 ? _d : {};
    var createOrderTabReduxState = (_f = (_e = store.getState().salesRepData) === null || _e === void 0 ? void 0 : _e.createOrderTab) !== null && _f !== void 0 ? _f : {};
    var _k = useState(false), openAlertBox = _k[0], setOpenAlertBox = _k[1];
    var _l = useState(0), redirectTabIndex = _l[0], setRedirectTabIndex = _l[1];
    var selectedProductData = ((_g = store.getState().salesRepData.productTableData) !== null && _g !== void 0 ? _g : []).selectedProductData;
    var tabsArray = (_h = Tabs()) === null || _h === void 0 ? void 0 : _h.filter(function (item) {
        return item.isActive;
    });
    useEffect(function () {
        if ((reduxActiveTabObj === null || reduxActiveTabObj === void 0 ? void 0 : reduxActiveTabObj.actionEvent) === EDIT_ORDER_FLAG) {
            if ((reduxActiveTabObj === null || reduxActiveTabObj === void 0 ? void 0 : reduxActiveTabObj.activeTabIndex) === 1) {
                // Regular (non-B2B) edit order - navigate to Create Order tab
                handleChangeTab(reduxActiveTabObj.activeTabIndex); //Go To Create Order Tab
            }
            else if ((reduxActiveTabObj === null || reduxActiveTabObj === void 0 ? void 0 : reduxActiveTabObj.activeTabIndex) && (reduxActiveTabObj === null || reduxActiveTabObj === void 0 ? void 0 : reduxActiveTabObj.activeTabIndex) !== 1) {
                // Handle B2B tab navigation for edit order
                // Navigate directly - DraftOrdersBL already validated it's a B2B order
                if (componentIndex !== reduxActiveTabObj.activeTabIndex) {
                    handleChangeTab(reduxActiveTabObj.activeTabIndex); //Go To B2B Create Order Tab
                }
            }
        }
        if ((reduxActiveTabObj === null || reduxActiveTabObj === void 0 ? void 0 : reduxActiveTabObj.activeTabIndex) !== 1 && (reduxActiveTabObj === null || reduxActiveTabObj === void 0 ? void 0 : reduxActiveTabObj.actionEvent) === REDIRECT_TAB_FLAG) {
            handleChangeTab(reduxActiveTabObj.activeTabIndex);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reduxActiveTabObj, reduxEditOrderDataObj]);
    function a11yProps(index) {
        return {
            id: "vertical-tab-".concat(index),
            "aria-controls": "vertical-tabpanel-".concat(index),
        };
    }
    var handleChange = function (event, newValue) {
        handleChangeTab(newValue);
        props === null || props === void 0 ? void 0 : props.setMobileOpen(false);
    };
    var handleChangeTab = function (index, isTabClick) { return __awaiter(_this, void 0, void 0, function () {
        var activeTabsBeforeB2B, selectFeatures, leavingSalesOrderDetails;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            if ((reduxEditOrderDataObj === null || reduxEditOrderDataObj === void 0 ? void 0 : reduxEditOrderDataObj.actionEvent) !== EDIT_ORDER_FLAG &&
                (reduxActiveTabObj === null || reduxActiveTabObj === void 0 ? void 0 : reduxActiveTabObj.activeTabIndex) === 1 &&
                ((createOrderTabReduxState === null || createOrderTabReduxState === void 0 ? void 0 : createOrderTabReduxState.customerName) || (createOrderTabReduxState === null || createOrderTabReduxState === void 0 ? void 0 : createOrderTabReduxState.productSelectedArrayLength) > 0 || (selectedProductData === null || selectedProductData === void 0 ? void 0 : selectedProductData.length) > 0)) {
                setRedirectTabIndex(index);
                return [2 /*return*/, setOpenAlertBox(true)];
            }
            activeTabsBeforeB2B = 0;
            selectFeatures = (_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.baseData) === null || _b === void 0 ? void 0 : _b.select;
            // Dashboard (index 0) is always active
            activeTabsBeforeB2B++;
            // Create Order tab (index 1) - check if active
            if ((selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateInvoice) || (selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateCheckout) || (selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateOrder)) {
                activeTabsBeforeB2B++;
            }
            // Clear Redux data ONLY on manual tab switching (not during edit order redirect)
            // During edit order redirect, we need to preserve data so it can patch correctly
            if (isTabClick) {
                // Manual tab switch - clear all Redux data to prevent data carryover
                handleReduxUpdate({}, SalesRepDataActionType.CUSTOMER_DETAILS_CREATE_INVOICE);
                handleReduxUpdate({}, SalesRepDataActionType.CREATE_ORDER_TAB);
                handleReduxUpdate({}, SalesRepDataActionType.EDIT_DRAFT_ORDER);
                handleReduxUpdate([], SalesRepDataActionType.DRAFT_ORDER_DATA);
                handleReduxUpdate({}, SalesRepDataActionType.PRODUCT_TABLE_DATA);
            }
            leavingSalesOrderDetails = ((_c = tabsArray[componentIndex]) === null || _c === void 0 ? void 0 : _c.index) === SALES_ORDER_DETAILS_MAIN_TAB_INDEX &&
                ((_d = tabsArray[index]) === null || _d === void 0 ? void 0 : _d.index) !== SALES_ORDER_DETAILS_MAIN_TAB_INDEX;
            if (leavingSalesOrderDetails) {
                dispatch(refreshStReportsThirtyDayCacheInBackground());
            }
            props === null || props === void 0 ? void 0 : props.setActiveTab(tabsArray[index]);
            SetComponentIndex(index);
            setRedirectTabIndex(index);
            handleReduxUpdate({ activeTabIndex: index, actionEvent: "" }, SalesRepDataActionType.ACTIVE_TAB);
            return [2 /*return*/];
        });
    }); };
    var handleReduxUpdate = function (payloadData, actionType) {
        var updateReduxState = {
            payload: payloadData,
            type: actionType,
        };
        dispatch(updateReduxState);
    };
    return { handleChange: handleChange, componentIndex: componentIndex, handleChangeTab: handleChangeTab, tabsArray: tabsArray, a11yProps: a11yProps, openAlertBox: openAlertBox, setOpenAlertBox: setOpenAlertBox, redirectTabIndex: redirectTabIndex };
}
export var useDrawerContext = function () {
    var context = React.useContext(DrawerContext);
    if (!context) {
        throw new Error("useDrawerContext must be used within a DrawerProvider");
    }
    return context;
};
